export type MediaType = "movie" | "tv" | "variety";

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  popularity: number;
  addedAt: string;
  summary: string;
  cover: string;
}

export const TYPE_LABELS: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};